module.exports = __webpack_public_path__ + "media/images/product/p_q-51d67d0fb3b037f19c9adf04debe647b.png";